import { IdTypes, createFeatureScope } from 'bundles/product-features';

const { useProductFeatures } = createFeatureScope({
  enterprise: {
    enableOptimizedLearnerFlow: false, // Default value
    enableRecoveryEmailPrompts: true,
    enableEnterpriseTermsOfUseModal: true,
    enableUnifiedSso: false,
  },
});

// Product feature toggle to opt out orgs https://www.coursera.org/internal/feature-toggles?name=enableOptimizedLearnerFlow&namespace=enterprise
const useLearnerFlowOptimization = (orgId?: string) => {
  const { features, loading } = useProductFeatures({
    idType: IdTypes.Organization,
    id: orgId || '', // Empty string since we skip below if no org id
    skip: !orgId,
    ssr: true,
  });

  return {
    loading,
    isEnabled: features.get('enterprise', 'enableOptimizedLearnerFlow'),
  };
};

// Product feature toggle to opt out orgs https://www.coursera.org/internal/feature-toggles?name=enableRecoveryEmailPrompts&namespace=enterprise
const useEnterpriseFeatureFlags = (orgId?: string) => {
  const { features, loading } = useProductFeatures({
    idType: IdTypes.Organization,
    id: orgId || '', // Empty string since we skip below if no org id
    skip: !orgId,
    ssr: true,
  });

  return {
    isLoading: loading,
    isRecoveryEmailEnabled: features.get('enterprise', 'enableRecoveryEmailPrompts'),
    isTncsScreenEnabled: features.get('enterprise', 'enableEnterpriseTermsOfUseModal'),
    isUnifiedSsoEnabled: features.get('enterprise', 'enableUnifiedSso'),
  };
};

export { useLearnerFlowOptimization, useEnterpriseFeatureFlags };
